import { datasToPaymentServerData } from "@domains/payment/utils";
import { useNewNavigate, usePaymentRoomValue, usePensionNameValue } from "@shared/client";
import { usePostBooking } from "@shared/server";
import { iamPort } from "@utils/iamPort";
import { requestDataIMP } from "@utils/requestToDataIMP";
import { PaymentFormInputProps } from "../types";
import { useGetIMPResponse } from "./useGetIMPResponse";

export const usePayment = () => {
    const selectRoomList = usePaymentRoomValue();
    const pensionName = usePensionNameValue();
    const { onNavigate } = useNewNavigate();
    const { requestToServerFormData } = useGetIMPResponse();
    const { mutate } = usePostBooking();
    const onSubmitHandler = async (data: PaymentFormInputProps) => {
        const { paymentServerDataArray, totalPayPrice } = datasToPaymentServerData(data, selectRoomList);
        mutate(paymentServerDataArray, {
            onSuccess: (response) => {
                if (response.status === "400") {
                    alert(response.message);
                    return;
                }

                if ((response.status === "200" && response.pay_memo === null) || response.pay_memo === undefined) {
                    //카드 대행결제
                    const requestIMP = requestDataIMP({
                        formData: data,
                        merchant_uid: response.orderNum,
                        name: pensionName as string,
                        amount: totalPayPrice,
                        custom_data: {
                            ...paymentServerDataArray,
                        },
                    }) as object;
                    const { responseIMP } = requestToServerFormData(response.orderNum);
                    iamPort({ requestIMP, responseIMP });
                } else {
                    sessionStorage.setItem(`${response.orderNum}`, JSON.stringify(response));
                    onNavigate({ path: "/complete", params: { orderNum: response.orderNum } });
                }
            },
        });
    };

    return { onSubmitHandler };
};
